<script setup>

import { ref } from "vue";
import { useStore } from "vuex";
import { errorHandler } from "@/lib/errorHandler";
import { useRouter } from "vue-router";

const store = useStore();

const code = ref('');

const router = useRouter();

function fetchEventByCode() {
  store.dispatch('fetchCurrentEventByCode', code.value).then((response) => {

    if (!response?.data?.length) {
      return errorHandler({ name: 'lobbyNotFound' });
    }

    router.push({ name: 'personalLobbyPage', params: { code: code.value } });
  });
}


</script>

<template>
  <section class="section code">
    <div class="code-filling container">
      <div class="code-content">
        <div class="code-decoration-wrapper">
          <div class="code-decoration">
            <img src="@/assets/new-icons/test-data/code-decoration-1.png" alt=""
              class="code-decoration__img code-decoration__img--1">
            <img src="@/assets/new-icons/test-data/code-decoration-2.png" alt=""
              class="code-decoration__img code-decoration__img--2">
            <p class="code-decoration-text code-decoration-text--1">Экскурсии</p>
            <p class="code-decoration-text code-decoration-text--2">Друзья</p>
            <p class="code-decoration-text code-decoration-text--3">Прогулки</p>
          </div>
        </div>
        <div class="code-enter">
          <p class="code-enter__title">Ввести код и присоединиться к мероприятию </p>
          <label class="code-input">
            <input type="text" v-model="code" class="code-input__field" placeholder="Ввести код" maxlength="4">
            <button class="code-input__btn" @click="fetchEventByCode">
              <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M24.9824 17.2502L18.2324 24.0002L20.0002 25.768L28.8841 16.8841C29.1185 16.6497 29.2502 16.3317 29.2502 16.0002C29.2502 15.6687 29.1185 15.3507 28.8841 15.1163L20.0002 6.23242L18.2324 8.00019L24.9825 14.7502L2.75 14.7502V17.2502L24.9824 17.2502Z"
                  fill="#fff" />
              </svg>
            </button>
          </label>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.code {
  padding: 6.25rem 0;


  &-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 3.125rem;
    margin-left: 4.5rem;
  }

  &-decoration {
    &-wrapper {
      max-width: 34.12rem;
      width: 100%;
    }

    position: relative;
    background: linear-gradient(135deg, #fff 0%, #d0ddff 100%);
    border-radius: 1.75rem;
    padding-bottom: 100%;
    max-width: 100%;
    width: 100%;

    &__img {
      position: absolute;
      border-radius: 1.25rem;

      &--1 {
        width: 18.31rem;
        height: 26.81rem;
        right: -2.5rem;
        top: -2.5rem;
      }

      &--2 {
        width: 14.62rem;
        height: 14.62rem;
        left: -4.5rem;
        bottom: 2.5rem;
      }
    }

    &-text {
      font-size: 1.5rem;
      line-height: 133%;
      letter-spacing: 0.01em;
      color: #454545;
      padding: 1rem 2.75rem;
      position: absolute;
      background: #fff;
      border-radius: 3.75rem;

      &--1 {
        top: 3.875rem;
        right: 11.3125rem;
      }

      &--2 {
        left: 1.625rem;
        bottom: 15rem;
      }

      &--3 {
        right: 4.3125rem;
        bottom: 2.5rem;
      }
    }
  }

  &-enter {
    max-width: 34rem;

    &__title {
      font-weight: 500;
      font-size: 3.5rem;
      line-height: 120%;
    }
  }

  &-input {
    display: flex;
    margin-top: 3rem;
    max-width: 25rem;
    align-items: center;
    width: 100%;
    gap: 1.5rem;
    padding: 0.25rem;
    background: #f6f6f6;
    border-radius: 12.5rem;

    &__field {
      margin: 0;
      background: none;
      border: none;
      font-size: 1.12rem;
      line-height: 133%;
      color: #404040;

      &::placeholder {
        color: #404040;
      }
    }

    &__btn {
      width: 3rem;
      height: 3rem;
      background: #D72D41;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
      flex-shrink: 0;

      svg {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }

  @media (max-width: 1100px) {
    padding: 2rem 0;

    &-content {
      flex-direction: column;
      margin: 0;
    }

    &-decoration {
      &-wrapper {
        max-width: 25rem;
      }

      &__img {

        &--1 {
          width: 10.31rem;
          height: auto;
          right: -0.5rem;
          top: -1.5rem;
        }

        &--2 {
          width: 10.62rem;
          height: auto;
          left: -0.5rem;
          bottom: 1.5rem;
        }
      }

      &-text {
        font-size: 1.25rem;
        color: #454545;
        padding: 0.75rem 1rem;
        border-radius: 2rem;

        &--1 {
          top: 0.875rem;
          right: 7.313rem;
        }

        &--2 {
          left: 1.625rem;
          bottom: 13rem;
        }

        &--3 {
          right: unset;
          bottom: 2.5rem;
          left: 8rem;
        }
      }
    }

    &-enter {
      max-width: 100%;

      &__title {
        font-size: 2rem;
        line-height: 130%;
      }
    }

    &-input {
      display: flex;
      margin-top: 2rem;
      max-width: 25rem;
      align-items: center;
      width: 100%;
      gap: 1.5rem;
      padding: 0.25rem;
      background: #f6f6f6;
      border-radius: 12.5rem;

      &__field {
        margin: 0;
        background: none;
        border: none;
        font-size: 1.12rem;
        line-height: 133%;
        color: #404040;

        &::placeholder {
          color: #404040;
        }
      }

      &__btn {
        width: 3rem;
        height: 3rem;
        background: #D72D41;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        flex-shrink: 0;

        svg {
          width: 1.25rem;
          height: 1.25rem;
        }
      }
    }
  }

}
</style>